import { faBan, faLock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { StructureDto } from '@/endpoints/models'
import { StructureStatus } from '@/endpoints/schemas/enums'
import { useAppContext, useAppStore } from '@/hooks'
import { mainColors } from '@/styles'
import { isLocked, isLockedByMe } from '@/utils/locking'

interface FrozenIconProps {
	status: string | undefined | null
}

export const FrozenIcon = ({ status }: FrozenIconProps) => {
	const { t } = useAppContext()

	if (!status || status !== StructureStatus.FROZEN) {
		return null
	}

	return (
		<FontAwesomeIcon
			icon={faBan}
			size="sm"
			color={mainColors.frozen}
			title={t('FROZEN')}
		/>
	)
}

interface LockedIconProps {
	node: StructureDto
}

export const LockedIcon = ({ node }: LockedIconProps) => {
	const { t } = useAppContext()
	const user = useAppStore((state) => state.auth.user)

	if (!isLocked(node)) {
		return null
	}

	const lockedByMe = isLockedByMe(node, user)

	return (
		<FontAwesomeIcon
			icon={faLock}
			size="sm"
			color={lockedByMe ? mainColors.success : mainColors.danger}
			title={
				lockedByMe
					? t('LOCKED_BY_YOU')
					: t('LOCKED_BY_USER', [node.lockUserName as string])
			}
		/>
	)
}
